import { useParams } from "react-router-dom";
import RcmpLoading from "../../atoms/Loading";
import intl from "react-intl-universal"
import Table from "../../atoms/Table"

import styles from './index.module.scss';
import useDataApi from "../../../hooks/useDataApi";
import { fnGeStatusLogin } from "../../../services/auth";
import { useContext, useEffect, useState } from "react";
import { fnDecodeStorageToken } from "../../../utils/encodeLocalStorage";
import AuthContext from "../../../contexts/Auth";
import RcmpHeader from "../../atoms/Header";
import ContentBlank from "../../molecules/ContentBlank";
import { fnGetAutomationActivities, fnGetAutomationData, fnUpdateAutomation } from "../../../services/automation";
import { cDeadLineSlug, cInvolvedsSlug, cResponsiblesSlug, cStatusSlug, dCreationDateSlug } from "../../../constans/activity-slugs"
import noActivitiesIlustration from "../../../assets/img/no-activities-automation-illustration.svg"
import { Typography } from "@stardust-ds/react";
import RcmpCardUsers from "../../atoms/CardUsers";
import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    useReactTable,
} from "@tanstack/react-table"
import FieldsContext from "../../../contexts/Fields";
import { fnFormatDateFromUTC } from "../../../utils/date";
import automationContext from "../../../contexts/Automation";
import { RcmpTableField } from "../../organisms/TableField";
import RcmpModalAddActivity from "../../organisms/ModalAddActivity";
import { fnDeleteActivity, fnListActivities, fnUpdateActivity } from "../../../services/acitivities";
import { fnGetBlock } from "../../../services/blocks";
import { fnEditTextEvidence, fnGetEvidences, fnStoreEvidence } from "../../../services/evidences";
import { fnDeleteComent, fnListComments, fnStoreComent, fnUpdateComent } from "../../../services/comments";
import { getPaineis } from "../../../services/paineis";
import RcmpModalInfo from "../../organisms/ModalInfo";
import ModalConfirmDelete from "../../organisms/ModalAddPainelCancel";
import BoardContext from "../../../contexts/Board";

export default function RcmpAutomationActivities() {
    const params = useParams()
    const [oGetStatusLoginRes, fnGetStatusLoginReq] = useDataApi(fnGeStatusLogin)
    const [oGetAutomationNameRes, fnGetAutomationNameReq] = useDataApi(fnGetAutomationData)
    const [oGetAutomationActivitiesRes, fnGetAutomationActivitiesReq] = useDataApi(fnGetAutomationActivities)
    const [oUpdateActivityRes, fnUpdateActivityReq] = useDataApi(fnUpdateActivity)
    const [oGetCommentsRes, fnGetCommentsReq] = useDataApi(fnListComments)
    const [oBlockRes, fnGetBlockReq] = useDataApi(fnGetBlock)
    const [oSubmitEvidence, fnSubmitEvidenceReq, fnResetEvidenceRes] =
        useDataApi(fnStoreEvidence)
    const [oSubmitEditEvidence, fnSubmitEditEvidenceReq] = useDataApi(fnEditTextEvidence)
    const [oGetEvidenceList, fnOGetEvidenceList] = useDataApi(fnGetEvidences)
    const [oCreateCommentRes, fnCreateCommentReq] = useDataApi(fnStoreComent)
    const [oDeleteCommentRes, fnDeleteCommentReq] = useDataApi(fnDeleteComent)
    const [oUpadteCommentRes, fnUpadteCommentReq] = useDataApi(fnUpdateComent)
    const [oGetActivitiesRes, fnGetActivitiesReq] = useDataApi(fnListActivities)
    const [oGetPaineis, fnSubmitGetPaineis] = useDataApi(getPaineis)
    const [oDeleteActivityRes, fnDeleteActivityReq] = useDataApi(fnDeleteActivity)

    const { fnGetAutomationDataReq, oGetAutomationData } = useContext(automationContext)
    const { oUser } = useContext(AuthContext)
    const { fnGetFields } = useContext(FieldsContext)
    const { fnSetOCurrentBoard } = useContext(BoardContext)
    const { fnChangeCostumerReq, oChangeCostumerRes } = useContext(AuthContext)
    const [bChangeCostumer, setChangeCostumer] = useState(false)
    const [cAutomationName, fnSetCAutomationName] = useState("")
    const [aAutomationActivities, fnSetAAutomationActivities] = useState([])
    const [aNData, fnSetANData] = useState(aAutomationActivities)
    const [aColumns, fnSetColumns] = useState([])
    const [aHead, fnSetAHead] = useState([])
    const [aTableRow, fnSetATableRow] = useState([])
    const [aVisibleFields, fnSetAVisibleFields] = useState([])
    const [bIsOpenModal, fnSetBIsOpenModal] = useState(false)
    const [oCurrentActivity, fnSetOCurrentActivity] = useState({})
    const [oCurrentBlock, fnSetOCurrentBlock] = useState({})
    const [aEvidences, fnSetAEvidences] = useState([])
    const [aComments, fnSetAComments] = useState([])
    const [bIsDeleteConfirmationActivity, fnSetBIsDeleteConfirmationActivity] = useState(false)
    const [bIsDeleteActivity, fnSetBIsDeleteActivity] = useState(false)
    const [cCurrentActivityName, fnSetCCurrentActivityName] = useState("")

    const cUserTimezone = oUser?.data?.user_ctimezone || "America/Sao_Paulo"

    useEffect(() => {
        (async () => {
            if (aVisibleFields.length) return
            await fnGetStatusLoginReq()

            const response = await fnGetFields()
            const responseAutomation = await fnGetAutomationDataReq(params.aut_id)


            if (responseAutomation) {
                // set automations fields as board model fields
                const aAutomationFields = responseAutomation?.data?.fields || []
                const aBoardModelFields = aAutomationFields.map(oField => ({
                    ...oField,
                    opfd_nid: oField.field_id,
                    ombf_opfd_nid: oField.field_id,
                    opfd_cname: oField.name,
                    opfd_cslug: oField.slug,
                    ombf_brequired: oField?.required || "NOT_REQUIRED",
                    ombf_bautofill: oField?.autofill || false,
                    ombf_nposition: oField?.position || 0,
                }))

                fnSetOCurrentBoard({
                    board_model: {
                        fields: aBoardModelFields
                    },
                })
            }

            let aFields = response.data.filter(field => field.opfd_cslug === cResponsiblesSlug || field.opfd_cslug === "titulo")
            const cResponsiblesField = response.data.find(field => field.opfd_cslug === dCreationDateSlug)
            if (cResponsiblesField) {
                aFields.push(cResponsiblesField)
            }

            fnSetAVisibleFields(aFields)
        })()
    }, [oCurrentActivity])


    const table = useReactTable({
        data: aNData || [],
        columns: aColumns,
        columnResizeMode: "onChange",
        getCoreRowModel: getCoreRowModel(),
    });

    async function fnGetEvidencesList(nActivityId) {
        const response = await fnOGetEvidenceList(nActivityId)
        return response
    }


    useEffect(() => {
        if (!oSubmitEvidence.done && !oSubmitEvidence.data?.length) return
        (async () => {
            const UpdateEvidenceList = await fnGetEvidencesList(oCurrentActivity?.opat_nid)
            fnSetAEvidences(UpdateEvidenceList.data.reverse())
        })()
    }, [oSubmitEvidence, oSubmitEditEvidence])
    useEffect(() => {
        if (!oSubmitEditEvidence.done && !oSubmitEditEvidence.data?.length) return
        (async () => {
            const UpdateEvidenceList = await fnGetEvidencesList(oCurrentActivity?.opat_nid)
            fnSetAEvidences(UpdateEvidenceList.data.reverse())
        })()
    }, [oSubmitEditEvidence])

    function getValue(aValues, data) {

        let cValue = ""
        cValue = aValues?.values?.find((value) => value?.opfv_opfd_nid == data?.opfd_nid)


        const oValue = {
            opfv_cvalue: cValue?.opfv_cvalue,
            opfv_opfd_nid: cValue?.opfv_opfd_nid,
        }

        if (data.opfd_ctype === "SELECTION") {

            let value = aValues?.values?.find((value) => value?.opfv_opfd_nid == data?.opfd_nid)

            if (data?.opfd_cslug === cStatusSlug) {
                const statusText = value?.selected_option?.opfs_coption_name === "Done" ? "Concluida" : "Pendente"
                return {
                    opfv_cvalue: <td style={{ color: "#1ecb4f" }}>{statusText}</td>,
                    opfv_opfd_nid: data.opfd_nid,
                }
            } else {
                const optionName = value?.selected_option?.opfs_coption_name
                const optionColor = value?.selected_option?.opfs_coption_color
                return {
                    opfv_cvalue: (
                        <td style={{ color: optionColor }}>{optionName}</td>
                    ),
                    opfv_opfd_nid: data.opfd_nid,
                }
            }
        }


        if (data?.opfd_cslug === dCreationDateSlug) {
            const formattedDate = fnFormatDateFromUTC(oValue?.opfv_cvalue, "DD/MM/YYYY HH:mm", cUserTimezone)
            return {
                opfv_cvalue: (
                    <td >
                        {formattedDate}
                    </td>
                ),
                opfv_opfd_nid: data.opfd_nid,
            }
        }

        if (data.opfd_cslug === cResponsiblesSlug) {

            let aResponsibles = aValues?.responsibles?.map(activity =>
            ({
                user_cname: activity?.user_cname,
                user_cavatar: activity?.user_cavatar
            })
            )
            return {
                opfv_cvalue: <RcmpCardUsers aUsers={aResponsibles} bSmall={true} />,
                opfv_opfd_nid: data?.opfd_nid,
            }
        }

        if (data.opfd_cslug === cInvolvedsSlug) {

            let aResponsibles = aValues?.involveds?.map(responsible => {
                return {
                    user_cname: responsible?.user_cname,
                    user_cavatar: responsible?.user_cavatar
                }
            })
            return {
                opfv_cvalue: <RcmpCardUsers aUsers={aResponsibles} bSmall={true} />,
                opfv_opfd_nid: data?.opfd_nid,
            }
        }

        if (data.opfd_ctype?.toLowerCase() === "date") {
            const formattedDate = fnFormatDateFromUTC(oValue?.opfv_cvalue, "DD/MM/YYYY HH:mm", cUserTimezone)
            return {
                opfv_cvalue: formattedDate,
                opfv_opfd_nid: data.opfd_nid,
            }
        }

        if (
            data.opfd_ctype?.toLowerCase() === "text" ||
            data.opfd_ctype?.toLowerCase() === "description"
        ) {

            return {
                opfv_cvalue: oValue.opfv_cvalue,
                opfv_opfd_nid: data.opfd_nid,
            }
        }

        if (data.opfd_ctype?.toLowerCase() === "peoples") {
            return {
                opfv_cvalue: <RcmpCardUsers aUsers={oValue.opfv_cvalue} bSmall={true} />,
                opfv_opfd_nid: data.opfd_nid,
            }
        }

    }
    function fnCreateTableColumns(oActivity) {
        const columnHelper = createColumnHelper()
        const columns = aVisibleFields.map((data) => {

            const result = oActivity?.values ? getValue(oActivity, data)?.opfv_opfd_nid : data?.opvf_opfd_nid
            const nFieldId = `fieldid-${result} `
            return columnHelper.accessor(nFieldId, {

                id: data?.opfd_nid,
                cell: (info) => info.getValue(),
                header: data.opfd_cname,
                footer: `${data.opfd_ctype}-${data.opfd_cslug}-${oActivity?.status}`
            })

        })

        return columns
    }

    async function fnGetCommentsList(nActivityId) {
        const response = await fnGetCommentsReq(nActivityId)
        return response
    }

    async function fnOpenModalActivity(nActivityId, aActivities) {
        const oActivity = aActivities.filter(activity => activity.opat_nid === nActivityId)[0]
        const oFormatedActivity = {
            ...oActivity,
            opat_nid: oActivity?.opat_nid.toString(), // Convert to string
        }
        fnSetOCurrentActivity(oFormatedActivity)
        const response = await fnGetBlockReq(oActivity?.opat_opbl_nid)
        fnSetOCurrentBlock(response.data)
        fnSetBIsOpenModal(true)
        const cGetNameActivity = oFormatedActivity?.values?.find(value => value.opfv_opfd_nid === aVisibleFields[0].opfd_nid)
        fnSetCCurrentActivityName(cGetNameActivity?.opfv_cvalue)

        const validator = await fnSubmitGetPaineis("perPage=200")
        if (!validator.success) return

        const CommentsResponse = await fnGetCommentsList(nActivityId)
        fnSetAComments(CommentsResponse.data)
        await fnGetEvidencesList(nActivityId)
        fnSetAEvidences(oGetEvidenceList?.data?.data)
    }

    function fnHandleCloseActivityModal(e) {
        fnSetBIsOpenModal(false)
    }

    useEffect(() => {
        let aDataFOrmated = []
        aAutomationActivities?.map((oActivity) => {

            let fields = []
            fields["blockID"] = oActivity.opat_opbl_nid
            fields["activityID"] = oActivity.opat_nid
            fields["status"] = oActivity?.status
            aVisibleFields.map((data, i) => {
                fields["field_value_id"] = data.opfd_nid
                const result = getValue(oActivity, data)
                fields[`fieldid-${result?.opfv_opfd_nid} `] = result?.opfv_cvalue
                if (data?.opfd_ctype === "NUMBER") {
                    fields[`fieldNumber-${data?.opfd_nid}`] = result?.opfd_cprefix
                    fields[`fieldHasPrefix-${data?.opfd_nid}`] = result?.bHasPrefix
                    fields[`fieldNumberPrecision-${data?.opfd_nid}`] = result?.opfd_nprecision
                    fields[`name-${data?.opfd_nid}`] = data.opfd_cname
                }
            })
            aDataFOrmated.push(fields)
        })
        fnSetANData(aDataFOrmated)
        if (!aAutomationActivities?.length) {
            const aColumns = fnCreateTableColumns()
            fnSetColumns(aColumns)
            return
        }

        aAutomationActivities.map(oActivity => {
            const aColumns = fnCreateTableColumns(oActivity)
            fnSetColumns(aColumns)
        })
    }, [aAutomationActivities])

    useEffect(() => {
        if (!oGetStatusLoginRes.done) return
        const cPlanPath = process.env.PUBLIC_URL + "/plan"
        if (!fnDecodeStorageToken()?.bActive && window.location.pathname !== cPlanPath) {
            localStorage.setItem("automationUrl", window.location.href)
            window.location.href = cPlanPath
            return
        } else {
            (async () => {
                const response = await fnChangeCostumerReq(params.cust_nid)

                const automationName = await fnGetAutomationNameReq(params.aut_id)

                if (response.cStorageToken && automationName.success) {
                    localStorage.setItem('cStorageToken', response.cStorageToken);
                    fnSetCAutomationName(automationName.data.title)
                }
                setChangeCostumer(true)
            })()
        }
    }, [oGetStatusLoginRes, oUpdateActivityRes, oDeleteActivityRes])
    
    useEffect(() => {
        if (!params?.aut_id) return
        (async () => {
            const automationActivities = await fnGetAutomationActivitiesReq(params.aut_id)
            if (!automationActivities?.data) return
            fnSetAAutomationActivities(automationActivities.data)
            automationActivities.data.length === 1 && oCurrentActivity !== null && aVisibleFields.length && fnOpenModalActivity(automationActivities.data[0].opat_nid, automationActivities.data)

        })()
    }, [params?.aut_id, aVisibleFields])

    useEffect(() => {
        if (!oUpdateActivityRes.done && !oUpdateActivityRes.data?.length) return
        (async () => {
            fnHandleCloseActivityModal()
            fnSetOCurrentActivity(null)
            await fnGetAutomationDataReq(params.aut_id)
        })()
    }, [oUpdateActivityRes])

    useEffect(() => {
        let dataTableHead = []
        let dataTableRow = []
        table.getHeaderGroups().map((head) => {
            head.headers?.map((data) => {
                dataTableHead.push(data)
            })
        })
        table.getRowModel().rows.map((row) => {
            dataTableRow.push(row)
        })
        fnSetAHead(dataTableHead)
        fnSetATableRow(dataTableRow)
    }, [table.getHeaderGroups()])

    if (!bChangeCostumer) {
        return (
            <div className={styles.blankPageContainer}>

                <RcmpLoading bShow={true} />
            </div>

        )
    }


    function fnHandleOpenModalConfirmationDeleteActivity() {
        fnSetBIsDeleteConfirmationActivity(true)
        fnSetBIsOpenModal(false)
    }

    function fnHandleCancelModalConfirmationDeleteActivity() {
        fnSetBIsDeleteConfirmationActivity(false)
        fnSetBIsOpenModal(true)
    }

    function fnHandleDeleteActiviy() {
        fnSetBIsDeleteActivity(true)
        fnSetBIsDeleteConfirmationActivity(false)
    }
    function fnHandleCloseModalDeleteActivity() {
        fnSetBIsDeleteActivity(false)
        if (!bIsDeleteActivity) {

            fnSetBIsOpenModal(true)
        }
    }

    async function fnDeleteActivitySubmit(data) {
        const response = await fnDeleteActivityReq(oCurrentActivity?.opat_nid, data)
        if (response.success) {
            fnSetOCurrentActivity({})
            fnSetBIsOpenModal(false)
        }
        return

    }

    async function fnSubmitEvidence(data) {
        const response = await fnSubmitEvidenceReq(oCurrentActivity?.opat_nid, data)
        return response
    }
    async function fnSubmitComment(data) {
        const response = await fnCreateCommentReq(oCurrentActivity?.opat_nid, data)
        return response
    }
    async function fnSubmitUpdateComment(nCommentId, data) {
        const response = await fnUpadteCommentReq(nCommentId, data)
        return response
    }
    async function fnDeleteComment(nCommentId) {
        const response = await fnDeleteCommentReq(nCommentId)
        return response
    }

    async function fnSubmitGetActivities(nBlockId) {
        const response = await fnGetActivitiesReq(nBlockId)
        return response
    }

    const fnShowFetchAutomationMessage = () => {
        if (oGetAutomationNameRes.error || oChangeCostumerRes?.error) {
            if (oGetAutomationNameRes.error?.request?.status === 403 || oChangeCostumerRes?.error?.request?.status === 422) {
                return intl.get("automation_list_activities.not_permissions");
            }

            return intl.get("automation_list_activities.fetch_automation_error");
        }

        return intl.get("automation_list_activities.not_activities");
    }

    return (
        <div className={styles.automationContainer}>
            <RcmpHeader
                cTitlePage={cAutomationName}

            ></RcmpHeader>
            <div className={styles.contentContainer}>
                <ContentBlank cHeaderTitle={intl.get("automation_list_activities.pedding_activity")} bCanSearch={false}>
                    {aAutomationActivities.length ? <div className={styles.tableArea}>
                        <Table

                        >
                            <Table.THead>
                                <Table.HeadData>ID</Table.HeadData>
                                {aHead.map((data, i) => {
                                    if (data.column.columnDef.header === "Título") {
                                        return (
                                            <Table.HeadData key={i}>
                                                {intl.get("automation_list_activities.name")}
                                            </Table.HeadData>
                                        )
                                    }
                                    if (i === 1) {
                                        return (
                                            <>
                                                <Table.HeadData key={i}>
                                                    {intl.get("automation_list_activities.block")}
                                                </Table.HeadData>
                                                <Table.HeadData key={i}>
                                                    {data.isPlaceholder
                                                        ? null
                                                        : flexRender(data.column.columnDef.header, data.getContext()).toUpperCase()}
                                                </Table.HeadData>
                                            </>
                                        )
                                    }
                                    return (

                                        <Table.HeadData key={i}>
                                            {data.isPlaceholder
                                                ? null
                                                : flexRender(data.column.columnDef.header, data.getContext()).toUpperCase()}
                                        </Table.HeadData>
                                    )
                                })}
                            </Table.THead>
                            <Table.TBody>
                                {aTableRow.map((data, i) => {
                                    return (
                                        <>
                                            <Table.TRow key={i} onClick={() => fnOpenModalActivity(data.original.activityID, aAutomationActivities)}>
                                                <Table.TData key={i} className={styles.idContainer}><span>{data.original.activityID}</span></Table.TData>
                                                {
                                                    data.getVisibleCells().map((cell, i) => {


                                                        if (i === 0) {
                                                            return (
                                                                <>
                                                                    <Table.TData className={styles.tableDataBody}>
                                                                        {cell.getValue(cell.column.id) || "---"}
                                                                    </Table.TData>

                                                                </>
                                                            )
                                                        }
                                                        if (i === 1) {
                                                            return (
                                                                <>
                                                                    <Table.TData className={styles.tableDataBody}>
                                                                        {oGetAutomationData?.data?.data?.block.name}
                                                                    </Table.TData>
                                                                    <Table.TData className={styles.tableDataBody}>
                                                                        {cell.getValue(cell.column.id)}
                                                                    </Table.TData>
                                                                </>
                                                            )
                                                        }
                                                        return (
                                                            <Table.TData className={styles.tableDataBody} key={i}>
                                                                {cell.getValue(cell.column.id)}
                                                            </Table.TData>
                                                        )
                                                    })
                                                }
                                            </Table.TRow>
                                        </>
                                    )
                                }
                                )}
                            </Table.TBody>
                        </Table>

                    </div>

                        :
                        <div className={styles.notActivities}>

                            <>
                                <Typography Typography type="h5" color="#415364" textAlign="center">
                                    {fnShowFetchAutomationMessage()}
                                </Typography>
                                <img src={noActivitiesIlustration} />
                            </>

                        </div>
                    }
                </ContentBlank>

            </div>

            {bIsOpenModal && <RcmpModalAddActivity
                bIsOpen={bIsOpenModal}
                fnOnClose={(e) => fnHandleCloseActivityModal(e)}
                bIsEdit={true}
                fnCreateActivity={() => { }}
                fnUpdateActivity={fnUpdateActivityReq}
                oActivityRes={oUpdateActivityRes}
                oCurrentBlock={oCurrentBlock}
                oCurrentActivity={oCurrentActivity}
                fnSetOCurrentActivity={fnSetOCurrentActivity}
                fnSetBIsDeleteActivity={fnHandleOpenModalConfirmationDeleteActivity}
                fnSetBopenCustomFields={() => { }}
                bCanChange={true}
                fnSubmitEvidence={fnSubmitEvidence}
                fnSubmitComment={fnSubmitComment}
                fnDeleteComment={fnDeleteComment}
                oCreateCommentRes={oCreateCommentRes}
                fnSubmitUpdateComment={fnSubmitUpdateComment}
                fnSubmitGetActivities={fnSubmitGetActivities}
                aEvidences={aEvidences || oGetEvidenceList?.data?.data}
                fnSetAEvidences={fnSetAEvidences}
                aCommentsList={aComments}
                fnSetAComments={fnSetAComments}
                oSubmitEvidence={oSubmitEvidence}
                bReadOnly={false}
                fnEditEvidenceSubmit={fnSubmitEditEvidenceReq}
                bIsAutomationList={true}
            />}
            <RcmpModalInfo
                bIsOpen={bIsDeleteConfirmationActivity}
                buttonCancelText={intl.get("cancel")}
                buttonSaveText={intl.get("continue")}
                title={intl.get("BlocksPage.delete_activity")}
                description={intl.get("BlocksPage.operation_cannot_be_undone")}
                size={"sm"}
                fnHandleCancel={fnHandleCancelModalConfirmationDeleteActivity}
                fnHandleConfirm={fnHandleDeleteActiviy}
            />
            <ModalConfirmDelete
                fnOnClose={fnHandleCloseModalDeleteActivity}
                fnHandleDelete={fnDeleteActivitySubmit}
                bOnDelete={bIsDeleteActivity}
                isOpen={bIsDeleteActivity}
                headerText={intl.get("BlocksPage.delete_activity")}
                fnSetBDelete={bIsDeleteActivity}
                text={intl.get("BlocksPage.sure_to_delete_activity", {
                    activity: cCurrentActivityName,
                })}
            />

        </div>
    )
}